import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import kx from '@/gr/common/knockout/extended';
import { AggregateMetric, RawMetric } from '@/apps/timeSeriesViewer/models';
import { Format } from '@/gr/common/format';

require('./cellTooltip.css');

export default function cellTooltip(element: HTMLElement, inputDataDefinitionId: RawMetric | AggregateMetric, isSelected: kx.ReadOnlyObservable<boolean>) {
  return tippy(element, {
    onShow(instance) {
      instance.setContent(formulateTooltipText(inputDataDefinitionId, isSelected()));
    },
    placement: 'right-start',
    maxWidth: 500,
    delay: [250, 50],
    allowHTML: true,
    theme: 'input-grid'
  });
}

function formulateTooltipText(inputDataDefinitionId: RawMetric | AggregateMetric, isSelected: boolean) {
  const tooltipTexts = [] as [innerText: string, cssClass: string][];

  let prefix = '';
  let postfix = '';
  if (inputDataDefinitionId instanceof RawMetric || !inputDataDefinitionId.nonsensical) {
    // action
    tooltipTexts.push([`${isSelected ? 'Des' : 'S'}elect the series:`, 'tooltip-content-small']);

    // on what
    if (inputDataDefinitionId instanceof AggregateMetric) {
      prefix = 'The sum of ';
      postfix = '';
    }
  } else {
    tooltipTexts.push([`Grouping:`, 'tooltip-content-small']);
  }

  tooltipTexts.push([`${prefix}<strong>${inputDataDefinitionId.tooltipInfo?.displayName}</strong>${postfix}`, 'tooltip-content-emphasis']);

  if (inputDataDefinitionId instanceof AggregateMetric) {
    tooltipTexts.push([
      `Where:<br/>
        ${inputDataDefinitionId.facets.map((x) => `<span class="facet">${Format.string.pascalToDisplay(x.facetId)} = <strong>${x.valueId}</strong></span>`).join('<br/>')}`,
      'tooltip-content-emphasis'
    ]);
  }

  // extra metadata
  inputDataDefinitionId.tooltipInfo?.cadence && tooltipTexts.push([`${inputDataDefinitionId.tooltipInfo?.cadence}`, '']);
  inputDataDefinitionId.tooltipInfo?.unitsOfMeasure && tooltipTexts.push([`Units: ${inputDataDefinitionId.tooltipInfo?.unitsOfMeasure}`, '']);
  inputDataDefinitionId.tooltipInfo?.tooltip && tooltipTexts.push([inputDataDefinitionId.tooltipInfo?.tooltip, '']);

  // furhter actions
  if (inputDataDefinitionId instanceof AggregateMetric) {
    tooltipTexts.push(['Right click to select all subsets', 'tooltip-content-footer tooltip-content-small']);
  }

  return tooltipTexts.map(([x, y]) => `<div class="${y}">${x}</div>`).join('\n');
}
